import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
  paper: {
    width: 400,
    margin: "20% auto",
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #dcdcdc",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 4)
  },
  buttonContainer: {
      textAlign: "center"
  },
  button: {
    margin: theme.spacing(1),
  }
}));

export default function DecisionModal(props) {
  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  //const [modalStyle] = React.useState(getModalStyle);
  //const [open, setOpen] = React.useState(false);
  const handleYesDecisionMethod = () => {
    props.handleYesDecision()
    props.closeModal()
  }

  return (
    <div>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={props.show}
      >
        <div className={classes.paper}>
          <h2 id="simple-modal-title">
            ¿ Esta seguro que quiere eliminar este evento ?
          </h2>
          <div className={classes.buttonContainer}>
            <Button className={classes.button} variant="contained" color="primary" onClick={handleYesDecisionMethod}>SI</Button>
            <Button className={classes.button} variant="contained" color="primary" onClick={props.handleNoDecision}>NO</Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
